import { c as _c } from "react/compiler-runtime";
/* eslint-disable no-lonely-if */
import { TransitionProperties, TransitionState } from "@website/ui/transition/transition.types";
import { FC, useEffect, useRef, useState } from "react";
const TransitionV2: FC<TransitionProperties> = t0 => {
  const $ = _c(25);
  const {
    in: t1,
    timeout,
    unmountOnExit: t2,
    mountOnEnter: t3,
    children,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    enter: t4,
    exit: t5
  } = t0;
  const inProperty = t1 === undefined ? false : t1;
  const unmountOnExit = t2 === undefined ? false : t2;
  const mountOnEnter = t3 === undefined ? false : t3;
  const enter = t4 === undefined ? true : t4;
  const exit = t5 === undefined ? true : t5;
  const [state, setState] = useState("exited");
  const [initialRender, setInitialRender] = useState(mountOnEnter ? !inProperty : false);
  const timeoutReference = useRef(null);
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => () => {
      if (timeoutReference.current) {
        clearTimeout(timeoutReference.current);
      }
    };
    t7 = [];
    $[0] = t6;
    $[1] = t7;
  } else {
    t6 = $[0];
    t7 = $[1];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[2] !== inProperty || $[3] !== initialRender) {
    t8 = () => {
      if (initialRender && inProperty) {
        setInitialRender(false);
      }
    };
    t9 = [initialRender, inProperty];
    $[2] = inProperty;
    $[3] = initialRender;
    $[4] = t8;
    $[5] = t9;
  } else {
    t8 = $[4];
    t9 = $[5];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[6] !== enter || $[7] !== exit || $[8] !== inProperty || $[9] !== initialRender || $[10] !== onEnter || $[11] !== onEntered || $[12] !== onEntering || $[13] !== onExit || $[14] !== onExited || $[15] !== onExiting || $[16] !== state || $[17] !== timeout) {
    t10 = () => {
      if (initialRender) {
        return;
      }
      if (timeoutReference.current) {
        clearTimeout(timeoutReference.current);
        timeoutReference.current = null;
      }
      if (inProperty) {
        if (state === "exited") {
          if (!enter) {
            setState("entered");
            return;
          }
          onEnter?.();
          setState("entering");
          onEntering?.();
          const enterTimeout = typeof timeout === "number" ? timeout : timeout?.enter ?? 0;
          timeoutReference.current = setTimeout(() => {
            setState("entered");
            onEntered?.();
          }, enterTimeout);
        }
      } else {
        if (state === "entered") {
          if (!exit) {
            setState("exited");
            return;
          }
          onExit?.();
          setState("exiting");
          onExiting?.();
          const exitTimeout = typeof timeout === "number" ? timeout : timeout?.exit ?? 0;
          timeoutReference.current = setTimeout(() => {
            setState("exited");
            onExited?.();
          }, exitTimeout);
        }
      }
      return () => {
        if (timeoutReference.current) {
          clearTimeout(timeoutReference.current);
          timeoutReference.current = null;
        }
      };
    };
    t11 = [inProperty, state, enter, exit, timeout, onEnter, onEntering, onEntered, onExit, onExiting, onExited, initialRender];
    $[6] = enter;
    $[7] = exit;
    $[8] = inProperty;
    $[9] = initialRender;
    $[10] = onEnter;
    $[11] = onEntered;
    $[12] = onEntering;
    $[13] = onExit;
    $[14] = onExited;
    $[15] = onExiting;
    $[16] = state;
    $[17] = timeout;
    $[18] = t10;
    $[19] = t11;
  } else {
    t10 = $[18];
    t11 = $[19];
  }
  useEffect(t10, t11);
  const showChild = (!mountOnEnter || !initialRender) && (!unmountOnExit || state !== "exited");
  if (!showChild) {
    return null;
  }
  let t12;
  if ($[20] !== children || $[21] !== state) {
    t12 = children(state);
    $[20] = children;
    $[21] = state;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <>{t12}</>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export { TransitionV2 };